var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback, useState } from 'react';
import { BookingForm } from '../BookingForm/BookingForm';
import { CHECKOUT_CONTEXT_ENUM, setCheckoutContext, submitBookingForm } from '../../store/actions';
import { useDispatch, useSelector } from 'react-redux';
import { useBookingFormSchema } from "../BookingForm/schema";
import { ERoute } from '../../helpers/Routes';
import { useConfig } from '../../AppContext';
import { getResponseManager } from '../../responseManager/BeeResponseManager';
import { getBookDataPaginatedResponse } from '../../store/actions/response.actions';
import { useHadQuery } from '../../hooks/bookDataHooks';
export var BookingFormPage = function (props) {
    var dispatch = useDispatch();
    var _a = useState(false), hasQuery = _a[0], setHasQuery = _a[1];
    var showAsWizard = useConfig("bookingForm.showAsWizard", true)[0];
    var bookingFormSchema = useBookingFormSchema(props.name, [], { showAsWizard: showAsWizard });
    var hadQuery = useHadQuery();
    var showTimespanSearchAndSelect = useSelector(function (state) {
        var _a, _b, _c;
        if (hadQuery)
            return true;
        if (hasQuery)
            return true;
        var bookEntities = getBookDataPaginatedResponse(state.responseReducer)[0];
        var maxCount = Math.max(+(((_a = state.courseReducer.additionalProps) === null || _a === void 0 ? void 0 : _a.debugTimespanCount) || state.courseReducer.pageSize), 0);
        return ((_c = (_b = getResponseManager(bookEntities).pagination()) === null || _b === void 0 ? void 0 : _b.total) !== null && _c !== void 0 ? _c : 0) > maxCount;
    });
    var onSubmit = useCallback((function (request) {
        dispatch(setCheckoutContext(CHECKOUT_CONTEXT_ENUM.BOOK_NOW));
        dispatch(submitBookingForm(request, ERoute.BOOKCART));
    }), [dispatch]);
    var formProps = __assign(__assign({}, props), { onSubmit: onSubmit,
        setHasQuery: setHasQuery, getSchema: function (schema, wizProps, validationErrors) { return bookingFormSchema.getWizSchema(schema, wizProps, validationErrors); } });
    return React.createElement(BookingForm, __assign({}, formProps, { showTimespanSearchAndSelect: showTimespanSearchAndSelect, showSaveParticipants: true }));
};
